module.exports = __webpack_public_path__ + "img/QRK.7600e9fd.svg";